import { render, staticRenderFns } from "./BaseActions.vue?vue&type=template&id=66c9303e"
import script from "./BaseActions.vue?vue&type=script&lang=ts"
export * from "./BaseActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports